export const FortressTrivia = [
    {
        question: "What is the Tower of London's official name?",
        correct: "Her Majesty's Royal Palace and Fortress of the Tower of London",
        incorrect: ["Her Majesty's Armory at the Tower of London", "The Royal Fortress of the Tower of London", "Her Majesty's Royal Palace at the Tower of London"]
    },
    {
        question: "What are the small, glassless windows (generally used for archers) called?",
        correct: "An embrasure",
        incorrect: ["A loophole", "A shot-trap", "A redent"]
    },
    {
        question: "Who ordered the construction of the Crac des Chevaliers in Syria",
        correct: "Saint John of Jerusalem",
        incorrect: ["King Richard", "Al-Malik al-Zahir Rukn al-Din Baybars al-Bunduqdari", "Abu Kamil Nasr ibn Salih ibn Mirdas"]
    },
    {
        question: "In which of these decades was the term 'fortress' used most?",
        correct: "The 1820s",
        incorrect: ["The 1940s", "The 2010s", "The 1890s"]
    },
    {
        question: "Which of these is the largest fortress in the world?",
        correct: "Malbork Castle Zamek",
        incorrect: ["Edinburgh Castle", "Citadel of Aleppo", "Hohensalzburg Castle"]
    },
    {
        question: "Which of these is not a fortress?",
        correct: "Panagia Paraportiani",
        incorrect: ["The Tower of London", "Malbork Castle Zamek", "Crac des Chevaliers"]
    },
    {
        question: "Which fort was the starting place of the French-Indian war?",
        correct: "Fort LeBouef",
        incorrect: ["Fort de France", "Fort de la Mare", "Fort de la Côte"]
    },
    {
        question: "The type of fort called a Bastion fort generally looks like a...",
        correct: "Star",
        incorrect: ["Square", "Triangle", "Circle"]
    },

    // --- Castle anatomy ---
    {
        question: "What is the heavy latticed gate that drops down to seal a castle gateway?",
        correct: "A portcullis",
        incorrect: ["A barbican", "A machicolation", "A merlon"]
    },
    {
        question: "What is the fortified outpost built to guard a castle's main gate called?",
        correct: "A barbican",
        incorrect: ["A bailey", "A donjon", "A postern"]
    },
    {
        question: "In a motte-and-bailey castle, what exactly is the motte?",
        correct: "The raised earth mound",
        incorrect: ["The enclosed courtyard", "The surrounding ditch", "The wooden palisade"]
    },
    {
        question: "What is the outer walled courtyard of a castle called?",
        correct: "The bailey",
        incorrect: ["The motte", "The berm", "The glacis"]
    },
    {
        question: "What are the gaps in a battlement that defenders shot through?",
        correct: "Crenels",
        incorrect: ["Merlons", "Corbels", "Quoins"]
    },
    {
        question: "What is the solid raised block between two gaps in a battlement?",
        correct: "A merlon",
        incorrect: ["A crenel", "A machicolation", "A lintel"]
    },
    {
        question: "What are the floor openings in an overhanging parapet, used for dropping unpleasant things on attackers?",
        correct: "Machicolations",
        incorrect: ["Embrasures", "Corbels", "Oubliettes"]
    },
    {
        question: "What is the wall that runs between a castle's towers called?",
        correct: "A curtain wall",
        incorrect: ["A revetment", "A parapet", "A scarp"]
    },
    {
        question: "What is a small, concealed side entrance in a castle wall called?",
        correct: "A postern",
        incorrect: ["A garderobe", "A solar", "An undercroft"]
    },
    {
        question: "What was a castle's garderobe?",
        correct: "The toilet",
        incorrect: ["A wardrobe for armour", "The guards' barracks", "The herb garden"]
    },
    {
        question: "What is the walkway behind a battlement, where the defenders stood, called?",
        correct: "The allure",
        incorrect: ["The berm", "The glacis", "The counterscarp"]
    },
    {
        question: "What is a 'donjon'?",
        correct: "The great tower, or keep",
        incorrect: ["The castle prison", "The gatehouse", "The moat"]
    },
    {
        question: "What is an oubliette?",
        correct: "A cell reachable only through a hatch in the ceiling",
        incorrect: ["A castle chapel", "A siege tunnel", "An armoury"]
    },
    {
        question: "What was a 'murder hole'?",
        correct: "An opening above a gate passage for dropping missiles through",
        incorrect: ["A dungeon with no door", "A gap in the drawbridge", "A concealed archer's nest"]
    },
    {
        question: "What makes a castle 'concentric'?",
        correct: "One complete ring of walls built inside another",
        incorrect: ["A circular ground plan", "A round keep", "A perfectly circular moat"]
    },
    {
        question: "What was a castellan?",
        correct: "The governor of a castle",
        incorrect: ["The castle's chief mason", "The castle blacksmith", "A siege engineer"]
    },

    // --- Sieges ---
    {
        question: "What is a trebuchet?",
        correct: "A counterweight-powered siege engine",
        incorrect: ["A battering ram", "A wheeled siege tower", "A scaling ladder"]
    },
    {
        question: "What is it called when besiegers dig beneath a wall to bring it down?",
        correct: "Sapping",
        incorrect: ["Escalade", "Investment", "Enfilade"]
    },
    {
        question: "What is it called when attackers storm the walls with ladders?",
        correct: "An escalade",
        incorrect: ["A sortie", "A parley", "An investment"]
    },
    {
        question: "What is a counter-attack launched out of a besieged castle called?",
        correct: "A sortie",
        incorrect: ["An escalade", "A relief", "A siege train"]
    },

    // --- Star forts ---
    {
        question: "What is the projecting angular corner of a star fort called?",
        correct: "A bastion",
        incorrect: ["A ravelin", "A demilune", "A hornwork"]
    },
    {
        question: "What is the detached triangular outwork set in front of a star fort's wall?",
        correct: "A ravelin",
        incorrect: ["A bastion", "A caponier", "A glacis"]
    },
    {
        question: "What is the open, gently sloping ground cleared in front of a fortress called?",
        correct: "The glacis",
        incorrect: ["The berm", "The counterscarp", "The allure"]
    },

    // --- Famous castles ---
    {
        question: "Who ordered the building of the White Tower at the Tower of London?",
        correct: "William the Conqueror",
        incorrect: ["Henry VIII", "Richard the Lionheart", "Edward I"]
    },
    {
        question: "Which is the largest inhabited castle in the world?",
        correct: "Windsor Castle",
        incorrect: ["Prague Castle", "Edinburgh Castle", "Château de Chambord"]
    },
    {
        question: "Which of Edward I's Welsh castles was never finished?",
        correct: "Beaumaris Castle",
        incorrect: ["Conwy Castle", "Caernarfon Castle", "Harlech Castle"]
    },
    {
        question: "What is the largest castle in Wales?",
        correct: "Caerphilly Castle",
        incorrect: ["Conwy Castle", "Pembroke Castle", "Cardiff Castle"]
    },
    {
        question: "Roughly how many castle sites does Wales have?",
        correct: "About 600",
        incorrect: ["About 20", "About 60", "About 6,000"]
    },
    {
        question: "Edinburgh Castle is built on top of what?",
        correct: "An extinct volcanic plug",
        incorrect: ["A limestone cliff", "A glacial moraine", "A sandstone escarpment"]
    },
    {
        question: "Château Gaillard was thrown up in about two years by which king?",
        correct: "Richard the Lionheart",
        incorrect: ["Philip II of France", "John of England", "Henry II"]
    },
    {
        question: "Which crusading order held Krak des Chevaliers?",
        correct: "The Knights Hospitaller",
        incorrect: ["The Knights Templar", "The Teutonic Knights", "The Order of Santiago"]
    },
    {
        question: "Which order built Malbork Castle?",
        correct: "The Teutonic Knights",
        incorrect: ["The Knights Hospitaller", "The Knights Templar", "The Livonian Brothers of the Sword"]
    },
    {
        question: "Neuschwanstein Castle was built for which king?",
        correct: "Ludwig II of Bavaria",
        incorrect: ["Frederick the Great", "Maximilian I", "Otto I"]
    },
    {
        question: "Which Romanian castle is marketed, on thin evidence, as 'Dracula's Castle'?",
        correct: "Bran Castle",
        incorrect: ["Peleș Castle", "Corvin Castle", "Poenari Citadel"]
    },
    {
        question: "The walled city of Carcassonne is in which country?",
        correct: "France",
        incorrect: ["Spain", "Italy", "Portugal"]
    },
    {
        question: "The Alhambra fortress-palace overlooks which city?",
        correct: "Granada",
        incorrect: ["Seville", "Córdoba", "Toledo"]
    },
    {
        question: "Which Mughal emperor commissioned the Red Fort in Delhi?",
        correct: "Shah Jahan",
        incorrect: ["Akbar", "Aurangzeb", "Babur"]
    },
    {
        question: "Which Rajasthan fortress is known as the Golden Fort?",
        correct: "Jaisalmer Fort",
        incorrect: ["Amber Fort", "Mehrangarh Fort", "Chittorgarh Fort"]
    },
    {
        question: "Which Japanese castle is nicknamed the White Heron Castle?",
        correct: "Himeji Castle",
        incorrect: ["Matsumoto Castle", "Osaka Castle", "Nagoya Castle"]
    },
    {
        question: "Which Japanese castle is nicknamed the Crow Castle, for its black walls?",
        correct: "Matsumoto Castle",
        incorrect: ["Himeji Castle", "Kumamoto Castle", "Hikone Castle"]
    },
    {
        question: "The desert fortress of Masada overlooks which body of water?",
        correct: "The Dead Sea",
        incorrect: ["The Red Sea", "The Sea of Galilee", "The Mediterranean"]
    },
    {
        question: "The Citadel of Aleppo stands in which country?",
        correct: "Syria",
        incorrect: ["Lebanon", "Jordan", "Iraq"]
    },
    {
        question: "Under which dynasty did the Great Wall of China take the form we see today?",
        correct: "The Ming dynasty",
        incorrect: ["The Qin dynasty", "The Han dynasty", "The Tang dynasty"]
    }
]

const shuffle = (items) => {
    const shuffled = [...items]
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
    }
    return shuffled
}

/**
 * Pick a question and shuffle its answers, so the correct one isn't forever
 * the first button. Pass the question you just asked to avoid repeating it.
 */
export const getTriviaQuestion = (previous) => {
    const pool = previous
        ? FortressTrivia.filter((q) => q.question !== previous.question)
        : FortressTrivia
    const picked = pool[Math.floor(Math.random() * pool.length)]

    return {
        ...picked,
        answers: shuffle([
            { text: picked.correct, correct: true },
            ...picked.incorrect.map((text) => ({ text, correct: false })),
        ]),
    }
}
